import { ClientsDataTable } from '@/components/(clients_table)/components/ClientsDataTable'
import { createClientsTableColumns } from '@/components/(clients_table)/components/clientsTableColumns'
import { DashboardHeader } from '@/components/dashboard/dashboard-header'
import { DashboardShell } from '@/components/dashboard/dashboard-shell'
import { useTRPC } from '@/trpc/react'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/dashboard/hr_admin/clients/')({
  component: RouteComponent,
})

function RouteComponent() {
  const api = useTRPC()
  const { data: clients, isPending: isClientsPending } = useQuery({
    ...api.client.getClientsForBusiness.queryOptions(),
  })

  const columns = createClientsTableColumns({
    clientDetailRoute: '/dashboard/hr_admin/clients/$clientId',
  })

  return (
    <DashboardShell>
      <DashboardHeader heading="Clients" text="Manage your organization's clients." />
      <div className="space-y-4">
        {isClientsPending ? (
          <div className="rounded-md border p-4">
            <div className="text-center text-muted-foreground">Loading clients...</div>
          </div>
        ) : (
          <ClientsDataTable columns={columns} data={clients ?? []} />
        )}
      </div>
    </DashboardShell>
  )
}
